<template>
	<div class="container">
		<div class="panel">
			<div class="center-tabs">
				<div :class="['tab-item',{active:curr_tab == 'personal'}]" @click="curr_tab='personal'">个人资料</div>
				<div v-if="userInfo.designer_level_id>0" :class="['tab-item',{active:curr_tab == 'designer'}]" @click="curr_tab='designer'">设计师简介</div>
				<div :class="['tab-item',{active:curr_tab == 'brand'}]" @click="curr_tab='brand'">品牌管理</div>
			</div>
			<!-- <h2>个人资料</h2> -->
			<div class="form" v-if="curr_tab=='personal'">
				<div class="form-group">
					<div class="form-label">用户名：</div>
					<div class="form-control">
						<input type="text" class="input" readonly v-model="form_data1.username" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">注册日期：</div>
					<div class="form-control">
						<input type="text" class="input" readonly v-model="form_data1.create_time" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">手机号码：</div>
					<div class="form-control mobile-control">
						<input type="text" class="input" readonly placeholder="暂无手机号" :value="form_data1.mobile" />
						<span class="change-mobile-link" @click="openChangeMobile">{{ form_data1.mobile ? '更换手机号' : '绑定手机号' }}</span>
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">昵称：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请填写昵称" v-model="form_data1.nickname" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">真实姓名：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请填写真实姓名" v-model="form_data1.realname" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">性别：</div>
					<div class="form-control">
						<div class="sex-wrap">
							<div class="sex-item" :class="{active:form_data1.sex===1}" @click="choose_sex(1)">男<img v-if="form_data1.sex===1" src="../../assets/images/icon-selected2.png" class="selected" /></div>
							<div class="sex-item" :class="{active:form_data1.sex===2}" @click="choose_sex(2)">女<img v-if="form_data1.sex===2" src="../../assets/images/icon-selected2.png" class="selected" /></div>
						</div>
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">出生日期：</div>
					<div class="form-control">
						<input type="date" class="input" placeholder="请确认新密码" v-model="form_data1.birthday" />
					</div>
				</div>
				<div class="form-group" >
					<div class="form-label">所在地区：</div>
					<div class="form-control">
						<Cascader class="input1" :data="region" v-model="value"  placeholder="请选择省/市/区/街道"></Cascader>
					</div>
				</div>

				<div class=avatar-wrap>
					<img class="avatar" :src="form_data1.avatar|default_img" alt="">
					<Upload :action="upload_url"
							:data="{dir:'template'}"
							:show-upload-list="false"
							:on-success="handleSuccess"
					>
						<div class="btn-avatar">上传头像</div>
					</Upload>
				</div>

				<div class="btn-submit" @click="save1">保存</div>
			</div>
		</div>
		<!-- 版师信息（仅已入驻版师可见，走单独接口保存） -->
		<div class="panel" v-if="curr_tab=='personal' && Number(form_data1.is_pattern_maker) > 0">
			<h2>版师信息</h2>
			<div class="form">
				<div class="form-group">
					<div class="form-label">擅长品类：</div>
					<div class="form-control">
						<CheckboxGroup v-model="form_pm.cates" class="pm-checkbox-wrap">
							<div v-for="(item,index) in pm_category_list" :key="`pm-cate-${index}`" class="pm-checkbox-item" :title="item.name">
								<Checkbox :label="item.id">{{item.name}}</Checkbox>
							</div>
						</CheckboxGroup>
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">可接单时间：</div>
					<div class="form-control">
						<RadioGroup v-model="form_pm.work_time" class="pm-radio-wrap">
							<Radio label="0" class="pm-radio-item">24小时全天候</Radio>
							<Radio label="1" class="pm-radio-item">晚上</Radio>
							<Radio label="2" class="pm-radio-item">周末</Radio>
							<Radio label="3" class="pm-radio-item">晚上及周末</Radio>
						</RadioGroup>
					</div>
				</div>

				<div class="btn-submit" @click="savePMInfo">保存</div>
			</div>
		</div>

		<div class="panel" v-if="curr_tab=='personal'">
			<h2>修改密码</h2>
			<div class="form">
				<div class="form-group">
					<div class="form-label">新密码：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请输入新密码" v-model="form_data2.password" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">确认新密码：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请确认新密码" v-model="form_data2.confirm_password" />
					</div>
				</div>

				<div class="btn-submit" @click="save2">保存</div>
			</div>
		</div>
		<div class="panel" v-if="curr_tab=='personal'">
			<h2>银行账户</h2>
			<div class="form">
				<div class="bank-edit-wrapper">
					<div class="form-group">
						<div class="form-label">账户类型：</div>
						<div class="form-control">
							<RadioGroup v-model="form_bank.card_type">
								<Radio :label="1">对私</Radio>
								<Radio :label="2">对公</Radio>
                            </RadioGroup>
						</div>
					</div>
					
					<div class="form-group">
						<div class="form-label">开户行：</div>
						<div class="form-control">
							 <Select v-model="form_bank.card_code" filterable @on-change="changeBank" label-in-value>
								<Option v-for="item in banckList" :value="item.bank_code" :key="item.bank_code">{{ item.bank_name }}</Option>
							</Select>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户地址：</div>
						<div class="form-control">
							<Cascader class="input1" filterable :data="backArea" v-model="form_bank.bank_area"   placeholder="请选择开户地址"></Cascader>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户支行：</div>
						<div class="form-control">
							<Select v-model="form_bank.branch_code" filterable @on-change="changeBranch" label-in-value>
								<Option v-for="item in branchList" :value="item.branch_code" :key="item.branch_code">{{ item.branch_name }}</Option>
							</Select>
							
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户名称：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_name" placeholder="请输入持卡人姓名/对公账户名称" clearable />
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">银行卡号：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_no" type="number" placeholder="请输入银行卡号" clearable />
						</div>
					</div>
					
					
					<div class="form-group">
						<div class="form-label">手机号码：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_mobile" placeholder="请输入银行预留手机号码" clearable />
						</div>
					</div>
                    <!-- <div class="form-group">
						<div class="form-label">地址：</div>
						<div class="form-control">
							<Input v-model="form_bank.address" placeholder="请输入地址" clearable />
						</div>
					</div> -->
                    
                </div>

				<div class="btn-submit" @click="saveBank">保存</div>
			</div>
		</div>
		<div v-if="curr_tab === 'designer'" class="designer-form">
			<div class="top-form">
				<div class="designer-pic">
					<img :src="form_designer.designer_pic || require('@/assets/images/user-center/bg-default-designer-pic.png')" alt="" />
					<Upload
						action="/"
						:before-upload="(file)=>onBeforeUpload(file)"
						:format="['jpg', 'jpeg', 'png', 'gif','webp']"
						accept=".jpg,.jpeg,.png,.gif,.webp"
					>
						<div class="upload-btn">
							<img src="../../assets/images/user-center/icon-upload-designer-pic.png" alt="" class="btn-icon" />上传自己的形象照
						</div>
					</Upload>
				</div>
				<div class="basic-form">
					<div class="basic-title">
						<div class="title">编辑个人简介</div>
						<div class="desc">完善的简介有助于获得更多关注</div>
					</div>
					<div class="form-2-col">
						<div class="basic-form-group">
							<div class="form-label required">设计师姓名</div>
							<Input placeholder="请输入设计师姓名" v-model="form_designer.designer_name"></Input>
						</div>
						<div class="basic-form-group">
							<div class="form-label required">设计师头衔</div>
							<Input placeholder="请输入设计师头衔" v-model="form_designer.designer_title"></Input>
						</div>
					</div>
					<div class="form-1-col">
						<div class="basic-form-group">
							<div class="form-label required">擅长风格 <div class="label-tips">(可多选)</div></div>
							<Select multiple placeholder="请选择擅长风格" v-model="form_designer.designer_styles">
								<Option v-for="(item,index) in setting.styles" :key="`opt-index-${index}`" :label="item.title" :value="item.title"></Option>
								<!-- <Option label="风格2" value="风格2"></Option>
								<Option label="风格3" value="风格3"></Option>
								<Option label="风格4" value="风格4"></Option>
								<Option label="风格5" value="风格5"></Option> -->
							</Select>
						</div>
					</div>
					<div class="form-1-col">
						<div class="basic-form-group">
							<div class="form-label required">个人简介</div>
							<textarea placeholder="请输入个人简介" :rows="4" v-model="form_designer.designer_introduction" />
						</div>
					</div>
				</div>
			</div>
			<div class="other-form">
				<div class="label">其它简介及荣誉 <span class="label-tips">(支持自由编辑 可上传图片/视频)</span> </div>
				<Editor dir="user" v-model="form_designer.designer_hornor" @change="onChangeRichText"></Editor>
			</div>
			<div class="btn-box">
				<div class="btn-item reset" @click="form_designer={}">重置</div>
				<div class="btn-item confirm" @click="onSaveDeisgnerInfo">确认保存</div>
			</div>
		</div>
		<div v-if="curr_tab === 'brand'" class="brand-container">
			<div class="tabs-list">
				<div class="tab-group">
					<div v-for="(item,key) in brand_tabs" :key="key" :class="['tab-item',{'active':key === form_query_brand.status}]" @click="switchBrandTab(key)">{{item.name}}({{ item.count }})</div>
				</div>
				<div v-if="brandList.length > 0" class="add-btn" @click="addBrand">
					<Icon type="md-add" color="#ffffff" />
					添加品牌
				</div>
			</div>
			<div class="list-body">
				<template v-if="brandList.length > 0">
					<div class="brand-list">
						<div class="brand-card" v-for="item in brandList" :key="item.id">
							<div v-if="[0,2].includes(Number(item.status))" :class="['tag',{ing:Number(item.status) === 0,reject:Number(item.status) === 2}]">
								{{ Number(item.status) === 2 ? '已驳回' : '审核中' }}
							</div>
							<div class="card-left">
								<img :src="item.logo | default_img" alt="" class="brand-logo" />
							</div>
							<div class="card-center">
								<div class="brand-name">品牌名称:{{ item.name }}</div>
								<div class="brand-desc">{{ item.brand_desc || '暂无品牌介绍' }}</div>
								<div v-if="Number(item.status) === 2 && item.reason" class="reject-reason">驳回原因：{{ item.reason }}</div>
								<div class="cert-btn" @click="viewCert(item)">
									<img src="@/assets/images/brands/ico-certificate.png" class="cert-btn-icon" />
									查看品牌证书
								</div>
							</div>
							<div class="card-right">
								<div class="card-actions">
									<span v-if="item.status == 1" class="action-link" @click="viewBrand(item)">
										<img src="@/assets/images/brands/icon-view.png" class="action-icon" />查看详情
									</span>
									<span v-if="item.status != 1" class="action-link" @click="editBrand(item)">
										<img src="@/assets/images/brands/icon-edit.png" class="action-icon" />{{ item.status == 2 ? '重新提交' : '修改' }}
									</span>
									<span class="action-link" @click="deleteBrand(item.id)">
										<img src="@/assets/images/brands/icon-delete.png" class="action-icon" />删除
									</span>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div v-else class="empty-mode">
					<img src="@/assets/images/empty-brand.png" alt="" class="empty-icon" />
					<div class="empty-text-main">暂无服装品牌信息~</div>
					<div class="empty-text-sub">创建你的专属服装品牌库，统一管理品牌信息，提交资质审核后即可加入品牌库</div>
					<div class="add-btn" @click="addBrand">
						<Icon type="md-add" color="#ffffff" />
						添加我的第一个品牌
					</div>
				</div>
			</div>
	</div>
		<!-- 品牌详情弹窗 -->
		<Modal v-model="showBrandDetail" title="品牌详情" width="920">
			<div v-if="viewingBrand" class="brand-detail">
				<div class="detail-top">
					<div class="detail-left">
						<img v-viewer :src="viewingBrand.logo" alt="" class="detail-logo" />
					</div>
					<div class="detail-right">
						<div class="detail-name">{{ viewingBrand.name }}</div>
						<div class="detail-time">提交时间：{{ viewingBrand.create_time }}</div>
						<div class="detail-desc-label">品牌简介</div>
						<div class="detail-desc-value">{{ viewingBrand.brand_desc || '暂无品牌介绍' }}</div>
					</div>
				</div>
				<div class="detail-certs">
					<div class="detail-certs-label">品牌证书</div>
					<div class="detail-certs-list">
						<div class="detail-file-item" v-for="(file, i) in getCertFiles(viewingBrand)" :key="i">
							<div class="item-left">
								<template v-if="util.test_image(file.url)">
									<img class="file-icon" :src="file.url" alt="" v-viewer />
								</template>
								<template v-else>
									<a :href="file.url" target="_blank">
										<img class="file-icon" :src="util.get_image_icon(file.url)" alt="" />
									</a>
								</template>
								<div class="file-info">{{ file.name }}</div>
							</div>
						</div>
						<div v-if="!getCertFiles(viewingBrand).length" class="no-cert">暂无证书文件</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="brand-detail-footer" v-if="viewingBrand">
				<Button class="detail-footer-btn detail-footer-delete" @click="deleteBrand(viewingBrand.id)">删除品牌</Button>
				<Button class="detail-footer-btn detail-footer-edit" @click="editBrand(viewingBrand); showBrandDetail = false">
					修改信息
				</Button>
				<Button class="detail-confirm-btn" @click="showBrandDetail = false">确认</Button>
			</div>
		</Modal>
		<!-- 删除品牌确认弹窗 -->
		<Modal v-model="showDeleteConfirm" title="提示" width="420">
			<p style="text-align:center;font-size:14px;color:#333;">确定要删除该品牌吗？</p>
			<div slot="footer" style="display:flex;justify-content:center;gap:12px;">
				<Button @click="showDeleteConfirm = false">取消</Button>
				<Button type="primary" style="background-color:#ff5967;border-color:#ff5967;" @click="confirmDeleteBrand">确认</Button>
			</div>
		</Modal>
		<!-- 更换手机号 -->
		<Modal v-model="showChangeMobile" title="更换手机号" width="520" :mask-closable="false" @on-cancel="closeChangeMobile">
			<div class="change-mobile-form">
				<!-- 弹窗内联提示：全局 $layer 提示的 z-index（500 起）会被 Modal（1000 起）遮住 -->
				<div v-if="change_mobile_msg.text" class="change-mobile-msg" :class="change_mobile_msg.type">
					{{ change_mobile_msg.text }}
				</div>
				<div class="change-mobile-tip">
					{{ form_data1.mobile ? '为保障账号安全，需先验证当前手机号，再验证新手机号' : '绑定手机号后可使用手机号验证码登录' }}
				</div>
				<div v-if="form_data1.mobile" class="change-mobile-row">
					<div class="row-label">当前手机号</div>
					<div class="row-value readonly">{{ form_data1.mobile }}</div>
				</div>
				<div v-if="form_data1.mobile" class="change-mobile-row">
					<div class="row-label">原手机号验证码</div>
					<div class="row-value">
						<input type="text" class="row-input" maxlength="6" placeholder="请输入原手机号验证码" v-model="change_mobile_form.old_code" />
						<span class="code-link" :class="{disabled: old_code_counting}" @click="sendOldMobileCode">
							{{ old_code_counting ? old_code_count + 's后重发' : '获取验证码' }}
						</span>
					</div>
				</div>
				<div class="change-mobile-row">
					<div class="row-label">新手机号</div>
					<div class="row-value">
						<input type="text" class="row-input" maxlength="11" placeholder="请输入新手机号" v-model="change_mobile_form.new_mobile" />
						<!-- 占位：与「获取验证码」等宽，保证两个输入框右边界对齐 -->
						<span class="code-link placeholder" aria-hidden="true"></span>
					</div>
				</div>
				<div class="change-mobile-row">
					<div class="row-label">新手机号验证码</div>
					<div class="row-value">
						<input type="text" class="row-input" maxlength="6" placeholder="请输入新手机号验证码" v-model="change_mobile_form.new_code" />
						<span class="code-link" :class="{disabled: new_code_counting}" @click="sendNewMobileCode">
							{{ new_code_counting ? new_code_count + 's后重发' : '获取验证码' }}
						</span>
					</div>
				</div>
			</div>
			<div slot="footer" style="display:flex;justify-content:flex-end;gap:12px;">
				<Button @click="closeChangeMobile">取消</Button>
				<Button type="primary" :loading="change_mobile_loading" style="background-color:#ff5967;border-color:#ff5967;" @click="submitChangeMobile">
					{{ form_data1.mobile ? '确认更换' : '确认绑定' }}
				</Button>
			</div>
		</Modal>
		<!-- 添加品牌 -->
		<AddBrand v-if="showAddBrand" @close="showAddBrand=false" @success="onBrandCreated" :editData="editingBrand"></AddBrand>
	</div>
</template>

<script>
	import {
	categoryList,
	ChangeMobile,
	DeleteUserBrand,
	GetBankArea,
	GetBankList,
	GetBranchList,
	GetUserBank,
	GetUserBrandCount,
	GetUserBrandList,
	patternMakerInfo,
	Profile,
	RevisePassword,
	SaveProfile,
	SaveUserBank,
	SendSms,
	updatePMInfo,
} from "@/api/index.js";
import AddBrand from '@/components/AddBrand.vue';
import Editor from '@/components/WangEditor';
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util";
import { mapState } from 'vuex';

	export default {
		name: 'UserCenter',
		components: {
			AddBrand,
			Editor
		},
		data() {
			return {
				upload_url: process.uniEnv.BASE_API + '/util/upload-image',
				value: [],
				region: region,
			util: util,
				form_data1: {
					username: '',
					mobile: '',
					nickname:'',
					realname: '',
					sex: 0,
					birthday: '',
					province: '',
					city: '',
					zone: '',
					create_time: ''
				},
				form_data2: {
					password: '',
					confirm_password: '',
				},
				// 更换手机号
				showChangeMobile: false,
				change_mobile_form: {
					old_code: '',
					new_mobile: '',
					new_code: ''
				},
				// 弹窗内联提示（全局 $layer 提示会被 Modal 遮挡）
				change_mobile_msg: { type: '', text: '' },
				change_mobile_msg_timer: null,
				change_mobile_loading: false,
				old_code_counting: false,
				old_code_count: 60,
				new_code_counting: false,
				new_code_count: 60,
				old_code_timer: null,
				new_code_timer: null,
				curr_tab:'personal',
				form_pm:{
					cates:[],
					work_time:''
				},
				pm_category_list:[],
				form_designer:{
					designer_pic:""
				},
				form_bank:{
					card_type:1,
					card_name:'',
					card_no:'',
					card_bank:'',
					card_branch:'',
					card_mobile:'',
					address:'',
					branch_code:'',
					card_code:'',
					bank_area:[]
				},
				banckList:[],
				branchList:[],
				backArea:[],
				brand_tabs: {
					all: { name: "全部", count: 0 },
					pass: {name: "已审核", count: 0},
					wait_auth: {name: "待审核", count: 0},
					reject: {name: "已驳回", count: 0}
				},
				form_query_brand: {
					status: 'all'
				},
				showAddBrand:false,
				brandList:[],
				showBrandDetail:false,
			viewingBrand:null,
			editingBrand:null,
			showDeleteConfirm:false,
			deletingBrandId:null,
			};
		},
		computed:{
		...mapState({
			userInfo:(state)=>state.userInfo,
			setting:(state)=>state.setting
		}),
	},
		beforeDestroy() {
			// 离开页面时清理换绑验证码倒计时与内联提示
			this.clearMobileTimers()
			this.clearMobileMsg()
		},
		mounted() {
			// axios.all([
			// 	this.getProfile(),
			// ]).then(axios.spread((response1) => {

			// }))
			Promise.all([
				this.getProfile().then(()=> this.loadPMData()),
				this.getUserBank(),
				this.getBankList(),
				this.getBankArea(),
				this.getBrandList(),
			])
		},
		watch:{
        	'form_bank.bank_area'(news,olds){
				console.log(news)
            	this.geBranchList()
        	},
			
    	},
		methods: {
			addBrand(){
				this.editingBrand = null
				this.showAddBrand = true;
			},
			getCertPreview(item) {
				const files = this.parseCertFiles(item.cert_files)
				if (!files || files.length === 0) return null
				const first = files[0]
				const url = typeof first === 'object' ? first.url : first
				const name = typeof first === 'object' ? (first.name || '证书文件') : '证书文件'
				const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff)(\?|$)/i.test(url || '')
				return { url, name, isImage }
			},
			parseCertFiles(certFiles) {
				if (!certFiles) return []
				if (Array.isArray(certFiles)) return certFiles
				try {
					return JSON.parse(certFiles)
				} catch {
					return []
				}
			},
			editBrand(item){
				this.editingBrand = item
				this.showAddBrand = true;
			},
			viewCert(item) {
				const preview = this.getCertPreview(item)
				if (!preview) {
					this.$layer.msg('暂无证书文件')
					return
				}
				if (preview.isImage) {
					this.$viewerApi({
						images: [preview.url]
					})
				} else {
					window.open(preview.url, '_blank')
				}
			},
			viewBrand(item){
				this.viewingBrand = item
				this.showBrandDetail = true;
			},
			async deleteBrand(id){
			this.deletingBrandId = id
			this.showDeleteConfirm = true
		},
		async confirmDeleteBrand(){
			let res = await DeleteUserBrand({ id: this.deletingBrandId })
			if (res.code === 0) {
				this.$layer.msg('删除成功')
				this.showDeleteConfirm = false
				this.showBrandDetail = false
				this.getBrandList()
			} else {
				this.$layer.msg(res.msg || '删除失败')
			}
		},
			onBrandCreated(){
				this.showAddBrand = false
				this.getBrandList()
			},
			getCertFiles(brand){
				try {
					return JSON.parse(brand.cert_files) || []
				} catch {
					return []
				}
			},
			switchBrandTab(val) {
				this.form_query_brand.status = val;
				this.getBrandList();
			},
			async getBrandList(){
				let { data, code, msg } = await GetUserBrandList(this.form_query_brand)
				if(code>0){
					this.$layer.msg(msg);
					return;
				}
				this.brandList = data || []
				let {data:data_count, code:code_count, msg:msg_count} = await GetUserBrandCount()
				for (let code in data_count) {
						if(this.brand_tabs[code]){ // 先检查是否存在该键
							this.brand_tabs[code].count = data_count[code];
						}
				}
			},
			async getBankList() {
				let { data } = await GetBankList()
				this.banckList = data
			},
			async getBankArea() {
				let { data } = await GetBankArea()
				this.backArea = data
			},
			
			changeBank(e){
				this.form_bank.card_bank = e.label
				this.geBranchList()
			},
			
			async geBranchList(){
				let param = {
					bank_code:this.form_bank.card_code,
				}
				if(this.form_bank.bank_area){
					param.area_code = this.form_bank.bank_area[1]
				}
				let { data } = await GetBranchList(param)
				this.branchList = data
			},
			changeBranch(e){
				if(e){
					this.form_bank.card_branch = e.label
				}
			},
			async getUserBank(){
				let { data } = await GetUserBank()
				if(data){
					this.form_bank = data
				}
			},
			async saveBank() {
				console.log(this.form_bank)
				 if (!this.form_bank.card_name.trim()) {
					return this.$layer.msg('请输入开户名')
				}
				if (!this.form_bank.card_no.trim()) {
					return this.$layer.msg('请输入银行卡号')
				}
				if (!/^\d{16,19}$/.test(this.form_bank.card_no.replace(/\s/g, ''))) {
					return this.$layer.msg('请输入正确的银行卡号')
				}
				if (!this.form_bank.card_mobile.trim()) {
					return this.$layer.msg('请输入手机号码')
				}
				if (!/^1[3-9]\d{9}$/.test(this.form_bank.card_mobile)) {
					return this.$layer.msg('请输入正确的手机号码')
				}
				if (!this.form_bank.card_bank) {
					return this.$layer.msg('请选择开户行')
				}
				if (this.form_bank.bank_area.length == 0) {
					return this.$layer.msg('请选择开户地址')
				}
				if (!this.form_bank.card_branch) {
					return this.$layer.msg('请选择开户支行')
				}
				let { data,code } = await SaveUserBank(this.form_bank)
				this.$layer.msg(`保存成功`)
			},
			onChangeRichText(e){
				// console.log('e-rich',e);
				this.form_designer.designer_hornor = e;
				// console.log('this.form_designer',this.form_designer.designer_hornor);
			},
			onSaveDeisgnerInfo(){
				// console.log('designer_form',this.form_designer);
				// return;
				const {designer_hornor,designer_introduction,designer_name,designer_pic,designer_title,designer_styles} = this.form_designer;
				// if(!designer_hornor){
				// 	this.$layer.msg("请输入设计师介绍")
				// 	return
				// }
				if(!designer_introduction){
					this.$layer.msg("请输入设计师介绍")
					return
				}
				if(!designer_name){
					this.$layer.msg("请输入设计师姓名")
					return
				}
				if(!designer_pic){
					this.$layer.msg("请上传设计师头像")
					return
				}
				if(!designer_title){
					this.$layer.msg("请输入设计师头衔")
					return
				}
				if(!designer_styles.length){
					this.$layer.msg("请输入设计师风格")
					return
				}
				
				SaveProfile(this.form_designer).then(res=>{
					this.$layer.msg('保存成功~');
					this.getProfile();
				}).catch(({code,msg})=>{
					console.log('code',code,'msg',msg);
					this.$layer.msg(msg)
				})
			},
			onBeforeUpload(file){
				console.log('file',file);
				uploadFileToOSS(file,'template').then(url=>{
					this.$set(this.form_designer,'designer_pic',url);
				})
				return false;
			},
			handleSuccess(response, file, fileList) {
				this.form_data1.avatar = response.data.url
			},
			choose_sex(sex) {
				this.form_data1.sex = sex
			},
			save1() {
				this.form_data1.province = this.value[0]
				this.form_data1.city = this.value[1]
				this.form_data1.zone = this.value[2]
				// 手机号 / 用户名不允许通过保存资料修改，换绑必须走「更换手机号」的验证码流程
				const payload = Object.assign({}, this.form_data1)
				delete payload.mobile
				delete payload.username
				SaveProfile(payload).then(() => {
					this.$layer.msg(`保存成功`)
				}).finally(()=> {
					this.getProfile()
				})
			},
			// 版师信息：仅已入驻版师（user.is_pattern_maker）才加载
			async loadPMData(){
				if(!(Number(this.form_data1.is_pattern_maker) > 0)) return;
				await Promise.all([
					this.getPMCategoryList(),
					this.getPMInfo(),
				])
			},
			async getPMCategoryList(){
				try{
					let { data } = await categoryList();
					this.pm_category_list = data || [];
				}catch(e){
					console.log('err-pm-cate',e);
				}
			},
			async getPMInfo(){
				try{
					let { code, msg, data } = await patternMakerInfo();
					if(code > 0){
						this.$layer.msg(msg);
						return;
					}
					this.form_pm = {
						cates: (data.cates_id || []).map(item=>{return Number(item)}).filter(item=>{return item > 0}),
						work_time: data.work_time_val ? data.work_time_val.toString() : '0'
					}
				}catch(e){
					console.log('err-pm-info',e);
				}
			},
			savePMInfo(){
				if(!this.form_pm.cates.length){
					this.$layer.msg('请选择擅长品类')
					return
				}
				if(this.form_pm.work_time === ''){
					this.$layer.msg('请选择可接单时间')
					return
				}
				updatePMInfo({
					cates: this.form_pm.cates,
					work_time: this.form_pm.work_time
				}).then(()=>{
					this.$layer.msg('保存成功')
				}).catch(({msg})=>{
					this.$layer.msg(msg)
				})
			},
			save2() {
				if(!this.form_data2.password) {
					this.$layer.msg("请输入密码")
					return
				}
				if(!this.form_data2.confirm_password) {
					this.$layer.msg("请输入确认密码")
					return
				}
				if(this.form_data2.password != this.form_data2.confirm_password) {
					this.$layer.msg("两次密码不一致")
					return
				}
				RevisePassword(this.form_data2).then(() => {
					this.$layer.msg(`保存成功`)
				}).finally(()=> {
					this.getProfile()
					this.form_data2.password = this.form_data2.confirm_password = ''
				})
			},
			// ========== 更换手机号 ==========
			openChangeMobile() {
				this.change_mobile_form = { old_code: '', new_mobile: '', new_code: '' }
				this.clearMobileMsg()
				this.showChangeMobile = true
			},
			closeChangeMobile() {
				this.showChangeMobile = false
				this.clearMobileTimers()
				this.clearMobileMsg()
			},
			// 弹窗内联提示：vue-layer 的 z-index 从 500 起，低于 iView Modal（1000 起），
			// 全局 $layer 提示会被弹窗遮住，所以弹窗内的反馈统一走这里
			showMobileMsg(text, type = 'error') {
				if (this.change_mobile_msg_timer) {
					clearTimeout(this.change_mobile_msg_timer)
					this.change_mobile_msg_timer = null
				}
				this.change_mobile_msg = { type, text }
				this.change_mobile_msg_timer = setTimeout(() => {
					this.change_mobile_msg = { type: '', text: '' }
					this.change_mobile_msg_timer = null
				}, 3000)
			},
			clearMobileMsg() {
				if (this.change_mobile_msg_timer) {
					clearTimeout(this.change_mobile_msg_timer)
					this.change_mobile_msg_timer = null
				}
				this.change_mobile_msg = { type: '', text: '' }
			},
			clearMobileTimers() {
				if (this.old_code_timer) {
					clearInterval(this.old_code_timer)
					this.old_code_timer = null
				}
				if (this.new_code_timer) {
					clearInterval(this.new_code_timer)
					this.new_code_timer = null
				}
				this.old_code_counting = false
				this.new_code_counting = false
				this.old_code_count = 60
				this.new_code_count = 60
			},
			// 旧号 / 新号验证码各自独立倒计时
			startMobileCountdown(type) {
				const isOld = type === 'old'
				const countingKey = isOld ? 'old_code_counting' : 'new_code_counting'
				const countKey = isOld ? 'old_code_count' : 'new_code_count'
				const timerKey = isOld ? 'old_code_timer' : 'new_code_timer'
				this[countingKey] = true
				this[countKey] = 60
				if (this[timerKey]) {
					clearInterval(this[timerKey])
				}
				this[timerKey] = setInterval(() => {
					this[countKey]--
					if (this[countKey] <= 0) {
						clearInterval(this[timerKey])
						this[timerKey] = null
						this[countingKey] = false
						this[countKey] = 60
					}
				}, 1000)
			},
			sendOldMobileCode() {
				if (this.old_code_counting) return
				const mobile = this.form_data1.mobile
				if (!mobile) {
					this.showMobileMsg('当前账号未绑定手机号')
					return
				}
				SendSms({ mobile, scene: 'common' }).then(() => {
					this.showMobileMsg('验证码已发送', 'success')
					this.startMobileCountdown('old')
				}).catch((e) => {
					this.showMobileMsg((e && e.msg) || '验证码发送失败')
				})
			},
			sendNewMobileCode() {
				if (this.new_code_counting) return
				const mobile = (this.change_mobile_form.new_mobile || '').trim()
				if (!mobile) {
					this.showMobileMsg('请先输入新手机号')
					return
				}
				if (!/^1[3-9]\d{9}$/.test(mobile)) {
					this.showMobileMsg('请输入正确的手机号')
					return
				}
				if (mobile === this.form_data1.mobile) {
					this.showMobileMsg('新手机号不能与当前手机号相同')
					return
				}
				SendSms({ mobile, scene: 'common' }).then(() => {
					this.showMobileMsg('验证码已发送', 'success')
					this.startMobileCountdown('new')
				}).catch((e) => {
					this.showMobileMsg((e && e.msg) || '验证码发送失败')
				})
			},
			submitChangeMobile() {
				if (this.change_mobile_loading) return
				const oldMobile = this.form_data1.mobile
				const newMobile = (this.change_mobile_form.new_mobile || '').trim()
				// 尚未绑定手机号的账号走首次绑定，只需新号验证码
				if (oldMobile && !this.change_mobile_form.old_code) {
					this.showMobileMsg('请输入原手机号验证码')
					return
				}
				if (!newMobile) {
					this.showMobileMsg('请输入新手机号')
					return
				}
				if (!/^1[3-9]\d{9}$/.test(newMobile)) {
					this.showMobileMsg('请输入正确的手机号')
					return
				}
				if (newMobile === oldMobile) {
					this.showMobileMsg('新手机号不能与当前手机号相同')
					return
				}
				if (!this.change_mobile_form.new_code) {
					this.showMobileMsg('请输入新手机号验证码')
					return
				}
				this.change_mobile_loading = true
				ChangeMobile({
					old_mobile: oldMobile || '',
					old_code: this.change_mobile_form.old_code || '',
					new_mobile: newMobile,
					new_code: this.change_mobile_form.new_code
				}).then(() => {
					// 先关闭弹窗再给全局提示，避免提示被弹窗遮住
					this.closeChangeMobile()
					this.$layer.msg(oldMobile ? '手机号更换成功' : '手机号绑定成功')
					this.getProfile()
				}).catch((e) => {
					this.showMobileMsg((e && e.msg) || '手机号更换失败')
				}).finally(() => {
					this.change_mobile_loading = false
				})
			},
			async getProfile() {
				return Profile().then(response => {
					this.$store.commit('setUserInfo', this.$_.cloneDeep(response.data))
					this.form_data1 = response.data
					this.value = [this.form_data1.province, this.form_data1.city, this.form_data1.zone]
					const {designer_hornor,designer_introduction,designer_name,designer_pic,designer_title,designer_styles} = response.data;
					this.form_designer = {designer_hornor,designer_introduction,designer_name,designer_pic,designer_title,designer_styles};
					return response
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	.container {
		padding-bottom:180px;
		.panel {
			// margin-bottom: 10px;
			padding: 8px 30px 17px 30px;
			background: white;
			h2 {
				color: #333333;
				padding: 24px 0;
				border-bottom: 1px solid #EBEBEB;
				font-size: 18px;
				font-weight: bold;
			}
			.center-tabs{
				width:100%;
				padding-top:24px;
				padding-bottom:15px;
				border-bottom:1px solid #d6d6d6;
				display:flex;
				align-items:center;
				column-gap:48px;
				.tab-item{
					color:#666;
					font-size:16px;
					cursor:pointer;
					&.active{
						color:#1a1a1a;
						font-size:18px;
						font-weight:bold;
						position:relative;
						&::after{
							content:"";
							width:100%;
							height:3px;
							background:#ff5967;
							position:absolute;
							left:0;
							bottom:-15px;
						}
					}
				}
			}
			.form {
				position: relative;
				padding: 10px 0;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					.form-label {
						width: 100px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
					}
					.form-control {
						position: relative;
						.input {
							width: 300px;
							height: 48px;
							line-height: 48px;
							border: 1px solid #E3E3E3;
							border-radius: 10px;
							padding: 0 10px;
							outline: none;
							&[readonly] {
								border: none;
							}
						}

						.sex-wrap {
							display: flex;
							flex-wrap: nowrap;
							.sex-item {
								position: relative;
								width: 145px;
								height: 40px;
								line-height: 40px;
								text-align: center;
								border: 1px solid #E3E3E3;
								border-radius: 10px;
								margin: 0 5px;
								cursor: pointer;
								color: #363235;
								&.active {
									color: #FA3D5A;
									border-color: #FA3D5A;
								}
								.selected {
									position: absolute;
									bottom: 0;
									right: 0;
									width: 22px;
									height: 22px;
								}
							}
						}
					}


				}
				.avatar-wrap {
					position: absolute;
					top: 32px;
					right: 150px;
					.avatar {
						width: 120px;
						height: 120px;
						border-radius: 50%;
					}
					.btn-avatar {
						margin-top: 20px;
						width: 110px;
						height: 40px;
						line-height: 40px;
						background: #EDEFF2;
						border-radius: 10px 10px 10px 10px;
						font-size: 14px;
						color: #363235;
						text-align: center;
						cursor: pointer;
					}
				}
				.btn-submit {
					margin: 40px 0 0 40px;
					width: 110px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}
		.designer-form{
			display:flex;
			flex-direction:column;
			row-gap:33px;
			width:100%;
			max-width:1100px;
			padding: 8px 30px 17px 30px;
			background:#fff;
			.top-form{
				display:flex;
				column-gap:32px;
				width:100%;
				.designer-pic{
					width:300px;
					height:377px;
					border:1px solid #e3e3e3;
					border-radius:8px;
					overflow:hidden;
					position:relative;
					img{
						width:100%;
						height:100%;
						border-radius:8px;
						object-fit:cover;
						object-position: center;
					}
					.upload-btn{
						position:absolute;
						bottom:24px;
						left:60px;
						width:180px;
						height:40px;
						background:rgba(0,0,0,0.6);
						color:#fff;
						font-size:14px;
						display:flex;
						align-items:center;
						justify-content: center;
						column-gap:8px;
						border-radius:8px;
						cursor:pointer;
						.btn-icon{
							width:24px;
							height:24px;
						}
					}
				}
				.basic-form{
					display:flex;
					flex-direction:column;
					flex:1;
					.basic-title{
						display:flex;
						align-items:center;
						justify-content:space-between;
						margin-bottom:24px;
						.title{
							color:#333;
							font-size:18px;
							font-weight:bold;
						}
						.desc{
							color:#999;
							font-size:14px;
						}
					}
					.form-2-col{
						display:flex;
						column-gap:17px;
						margin-bottom:16px;
					}
					.form-1-col{
						width:100%;
						margin-bottom:16px;
					}
					.basic-form-group{
						display:flex;
						flex-direction:column;
						row-gap:10px;
						flex:1;

						.form-label{
							color:#333;
							font-size:14px;
							display:flex;
							align-items:center;
							&.required::after{
								content:"*";
								color:red;
							}
							.label-tips{
								color:#666;
								font-size:12px;
							}
						}
						::v-deep .ivu-input{
							width:100%;
							height:50px;
						}

						::v-deep .ivu-select{
							width:100%;
							height:50px;
							.ivu-select-selection{
								height:100%;
								display:flex;
								align-items:center;
							}
						}

						textarea{
							width:100%;
							// height:98px;
							padding:5px 10px;
							border:1px solid #e3e3e3;
							border-radius:8px;
							outline:none;
						}
					}
				}
			}
			.other-form{
				width:100%;
				display:flex;
				flex-direction:column;
				.label{
					color:#333;
					font-size:14px;
					display:flex;
					align-items:center;
					margin-bottom:16px;
					.label-tips{
						color:#999;
						font-size:14px;
					}
				}
			}
			.btn-box{
				display:flex;
				align-items:center;
				justify-content:center;
				width:100%;
				margin-top:20px;
				column-gap:16px;
				.btn-item{
					width:120px;
					height:40px;
					border-radius:4px;
					line-height:40px;
					text-align:center;
					cursor:pointer;
					font-size:14px;
					&.reset{
						border:1px solid #e3e3e3;
						color:#666;
					}
					&.confirm{
						color:#fff;
						background:#ff5967;
					}
				}
			}
		}

		.brand-container{
			display:flex;
			flex-direction:column;
			row-gap:33px;
			width:100%;
			padding: 0px 30px 17px 30px;
			background:#fff;
			.tabs-list{
				width:100%;
				display:flex;
				align-items:center;
				justify-content:space-between;
				.tab-group{
					display:flex;
					align-items:center;
					column-gap:16px;
				}
				.tab-item{
					color:#666;
					font-size:14px;
					line-height:32px;
					cursor:pointer;
					&.active{
						background:#ff5967;
						color:#fff;
						padding:2px 12px;
						border-radius:4px;
					}
				}
			}
			.list-body{
				width:100%;
				display:flex;
				align-items:center;
				justify-content:center;
				.brand-list{
					width:100%;
					display:flex;
					flex-wrap:wrap;
					gap:16px;
					.brand-card{
						display:flex;
						align-items:center;
						padding:16px 20px;
						border:1px solid #e8e8e8;
						border-radius:8px;
						column-gap:20px;
						width:calc(100% / 2 - 16px);
						position:relative;
						.tag{
							position:absolute;
							top:0;
							left:0;
							padding:4px 14px;
							border-radius:10px 0 10px 0;
							color:#fff;
							font-size:12px;
							z-index:10;
							&.ing{
								background:#ff7d00;
							}
							&.reject{
								background:#ff5967;
							}
						}
						.card-left{
							.brand-logo{
								width:150px;
								height:150px;
								border-radius:4px;
								object-fit:contain;
								border:1px solid #f0f0f0;
							}
						}
						.card-center{
							flex:1;
							min-width:0;
							padding-bottom:8px;
							> * {
								margin-bottom: 10px;
								&:last-child {
									margin-bottom: 0;
								}
							}
							.reject-reason{
								color:#ff5967;
								font-size:12px;
							}
							.brand-name{
								color:#000;
								font-size:14px;
								font-weight:500;
								width:100%;
								white-space:nowrap;
								text-overflow:ellipsis;
								overflow:hidden;
							}
							.brand-desc{
								color:#999;
								font-size:13px;
								line-height:18px;
								display:-webkit-box;
								-webkit-box-orient:vertical;
								-webkit-line-clamp:2;
								overflow:hidden;
								white-space:normal;
								word-break:break-all;
							}
						}
						.cert-btn{
							display:inline-flex;
							align-items:center;
							column-gap:4px;
							color:#0d99ff;
							font-size:13px;
							cursor:pointer;
							.cert-btn-icon{
								width:16px;
								height:16px;
							}
						}
					}
					.card-right{
						position:absolute;
						bottom:16px;
						right:20px;
						.card-actions{
							display:flex;
							align-items:center;
							column-gap:12px;
							.action-link{
								display:inline-flex;
								align-items:center;
								column-gap:3px;
								color:#666;
								font-size:13px;
								cursor:pointer;
								// &:hover{
								// 	color:#ff5967;
								// }
								// &.danger:hover{
								// 	color:#f56c6c;
								// }
							}
							.action-icon{
								width:14px;
								height:14px;
							}
						}
					}
					}
				}
				.empty-mode{
					display:flex;
					flex-direction:column;
					align-items:center;
					justify-content:center;
					.empty-icon{
						width:175px;
						height:175px;
						margin-bottom:13px;
					}
					.empty-text-main{
						color:#666;
						font-size:16px;
						margin-bottom:8px;
					}
					.empty-text-sub{
						color:#999;
						font-size:14px;
						margin-bottom:48px;
					}
				}
			}
			.list-footer{
				display:flex;
				justify-content:center;
				.add-btn{
					cursor:pointer;
					background:#ff5967;
					color:#fff;
					padding:10px 24px;
					display:inline-flex;
					align-items:center;
					column-gap:8px;
					border-radius:8px;
					font-size:14px;
				}
			}
		}
		.brand-detail{
			width:100%;
			overflow:hidden;
		.detail-top{
			display:flex;
			column-gap:32px;
			.detail-left{
				flex-shrink:0;
				width:280px;
				.detail-logo{
					width:100%;
					height:280px;
					background:#fff;
					object-fit:contain;
					border:1px solid #e8e8e8;
					border-radius:4px;
				}
			}
			.detail-right{
				flex:1;
				display:flex;
				flex-direction:column;
				align-items:flex-start;
				.detail-name{
					color:#000;
					font-size:16px;
					font-weight:500;
					width:100%;
					text-align:left;
					white-space:nowrap;
					text-overflow:ellipsis;
					overflow:hidden;
				}
				.detail-time{
					color:#999;
					font-size:12px;
					padding-bottom:12px;
					border-bottom:1px solid #e3e3e3;
					width:100%;
					text-align:left;
				}
				.detail-desc-label{
					color:#666;
					font-size:14px;
					margin-top:12px;
				}
				.detail-desc-value{
					color:#333;
					font-size:14px;
					margin-top:8px;
					white-space:pre-wrap;
					word-break:break-all;
					text-align:left;
				}
			}
		}
		.detail-certs{
			.detail-certs-label{
				color:#666;
				font-size:14px;
				margin-top:24px;
				text-align:left;
			}
			.detail-certs-list{
				margin-top:12px;
				.detail-file-item{
					background:#f8f9fb;
					border-radius:4px;
					display:flex;
					align-items:center;
					justify-content:space-between;
					padding:9px 12px 10px 8px;
					margin-bottom:8px;
					&:last-child{
						margin-bottom:0;
					}
					.item-left{
						display:flex;
						align-items:center;
						column-gap:8px;
						.file-icon{
							width:36px;
							height:36px;
							flex-shrink:0;
							object-fit:contain;
						}
						.file-info{
							color:#333;
							font-size:14px;
							max-width:600px;
							white-space:nowrap;
							text-overflow:ellipsis;
							overflow:hidden;
						}
					}
				}
				.no-cert{
					color:#999;
					font-size:14px;
				}
			}
		}
	}
	.brand-detail-footer{
		display:flex;
		align-items:center;
		column-gap:12px;
		justify-content:flex-end;
		.detail-footer-btn{
			background:#fff;
			border:1px solid #e3e3e3;
			color:#666;
			font-weight:500;
			border-radius:4px;
			padding:6px 24px;
			font-size:14px;
			&:hover{
				color:#ff5967;
				border-color:#ff5967;
			}
		}
		.detail-confirm-btn{
			background:#ff5967;
			color:#fff;
			border:1px solid #ff5967;
			border-radius:4px;
			padding:6px 24px;
			font-size:14px;
			&:hover{
				background:#e64e5a;
				border-color:#e64e5a;
				color:#fff;
			}
		}
	}

::v-deep .ivu-input {
		width: 300px;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
	
	::v-deep .ivu-select {
		width: 300px;
	}
	.bank-edit-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            .bank-edit-title-desc{
                width:100%;
                display:flex;
                flex-direction:column;
                row-gap:6px;
                margin-top:32px;
                .title{
                    color:#333;
                    font-weight:bold;
                    font-size:18px;
                }
                .desc{
                    color:#999;
                    font-size:14px;
                }
            }
            .form{
                display:flex;
                flex-direction:column;
                row-gap:32px;
                margin-top:32px;
                .form-item{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .item-label{
                        color:#333;
                        font-size:14px;
                        width:63px;
                        &.required::after{
                            content:"*";
                            color:red;
                        }
                    }
                    .item-value{
                        width:100%;
                        max-width:679px;
                    }
                }
            }
        }

		.add-btn{
			cursor:pointer;
			background:#ff5967;
			color:#fff;
			padding:10px 24px;
			display:flex;
			align-items:center;
			column-gap:8px;
			border-radius:8px;
			font-size:16px;
			.add-icon{
				width:16px;
				height:16px;
			}
		}

		::v-deep .ivu-modal-header-inner{
			font-size:20px;
			font-weight:bold;
			color:#0f1115;
		}

	.pm-checkbox-wrap{
		display:flex;
		flex-wrap:wrap;
		gap:12px;
		min-width:0;
		// max-width:900px;
		.pm-checkbox-item{
			width:140px;
			height:42px;
			border:1px solid #e3e3e3;
			border-radius:4px;
			display:flex;
			align-items:center;
			padding-left:16px;
			white-space:nowrap;
			overflow:hidden;
			text-overflow:ellipsis;
			::v-deep .ivu-checkbox-checked .ivu-checkbox-inner{
				border-color:#ff5967;
				background-color:#ff5967;
			}
		}
	}
	.pm-radio-wrap{
		display:flex;
		align-items:center;
		.pm-radio-item{
			width:100px;
			height:42px;
			display:flex;
			align-items:center;
			justify-content:center;
			white-space:nowrap;
			overflow:hidden;
			text-overflow:ellipsis;
		}
		::v-deep .ivu-radio-checked .ivu-radio-inner{
			border-color:#ff5967;
		}
		::v-deep .ivu-radio-inner:after{
			background-color:#ff5967;
		}
	}

	// ========== 更换手机号 ==========
	.mobile-control {
		display: flex;
		align-items: center;

		.change-mobile-link {
			margin-left: 12px;
			font-size: 14px;
			color: #ff5967;
			cursor: pointer;
			white-space: nowrap;

			&:hover {
				opacity: 0.8;
			}
		}
	}

	.change-mobile-form {
		padding: 0 4px;

		.change-mobile-msg {
			margin-bottom: 16px;
			padding: 8px 12px;
			border-radius: 4px;
			font-size: 13px;
			line-height: 1.5;

			&.success {
				color: #19be6b;
				background: #f0fbf5;
				border: 1px solid #c9f0dc;
			}

			&.error {
				color: #ed4014;
				background: #fef2f0;
				border: 1px solid #fbd6ce;
			}
		}

		.change-mobile-tip {
			font-size: 12px;
			color: #999999;
			line-height: 1.6;
			margin-bottom: 20px;
		}

		.change-mobile-row {
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			&:last-child {
				margin-bottom: 0;
			}

			.row-label {
				flex-shrink: 0;
				width: 112px;
				margin-right: 16px;
				font-size: 14px;
				color: #696A6A;
				text-align: right;
				white-space: nowrap;
			}

			.row-value {
				flex: 1;
				min-width: 0;
				overflow: hidden;
				display: flex;
				align-items: center;

				&.readonly {
					font-size: 14px;
					font-weight: 500;
					color: #333333;
					word-break: break-all;
				}

				.row-input {
					flex: 1;
					min-width: 0;
					box-sizing: border-box;
					height: 38px;
					line-height: 38px;
					border: 1px solid #E3E3E3;
					border-radius: 6px;
					padding: 0 12px;
					outline: none;
					font-size: 14px;
					transition: border-color 0.2s;

					&:focus {
						border-color: #ff5967;
					}
				}

				.code-link {
					flex-shrink: 0;
					width: 96px;
					margin-left: 12px;
					font-size: 13px;
					line-height: 38px;
					color: #ff5967;
					text-align: right;
					cursor: pointer;
					white-space: nowrap;

					&:hover {
						opacity: 0.8;
					}

					&.disabled {
						color: #C0C0C0;
						cursor: not-allowed;
					}

					// 仅占位、不可见，用于对齐「新手机号」输入框右边界
					&.placeholder {
						visibility: hidden;
						cursor: default;

						&:hover {
							opacity: 1;
						}
					}
				}
			}
		}
	}
</style>
